<sk-modal-content [title]="'label.dms.EditFolder' | translate"
                  confirmByKeypress
                  (confirmed)="onSubmit()"
                  (cancelled)="closeWithoutResult()"
                  [allowCancelIfChildFocused]="true"
                  [allowConfirmIfChildFocused]="true"
                  [suppressCancel]="fieldColor.colorDialogOpened$ | async"
                  [suppressConfirm]="fieldColor.colorDialogOpened$ | async"
                  (closed)="closeWithoutResult()">

  <ng-container id="sk-modal-body">
    <form [formGroup]="editFolderForm">
      @if (!isAdmin) {
        <sk-text
          [label]="'label.Name' | translate"
          required="true"
          data-test="folder-edit-modal_name"
          formControlName="name">
        </sk-text>
      } @else {
        <iris-field-translate
          [label]="'label.Name' | translate"
          formControlName="name"
          required="true"
          data-test="folder-edit-modal_name"
          [controlTemplate]="nameTemplate"
          [translations]="translations"
          (translationsChange)="folderNameTranslationsChanged($event)"
        ></iris-field-translate>
      }
      <sk-text
        [label]="'label.Description' | translate"
        data-test="folder-edit-modal_description"
        formControlName="comment">
      </sk-text>
      <sk-color
        [label]="'label.Color' | translate"
        data-test="folder-edit-modal_color"
        formControlName="color">
      </sk-color>

      @for (property of properties(); track property.id) {
        <div class="configurable_controls">
          @switch (property.name) {
            @case ('FlagSymbols') {
              <sk-select
                [label]="'label.' + property.name | translate"
                [items]="property.directory"
                bindLabel="name"
                bindValue="id"
                data-test="folder-edit-modal_flag-symbols"
                formControlName="customIconClass">
                <ng-template ng-option-tmp let-item="item">
                  <div class="d-flex align-items-center">
                    <i [class]="item.id"></i>
                    <span class="ps-2">{{item.name}}</span>
                  </div>
                </ng-template>
              </sk-select>
            }
            @default {
              <sk-select
                [label]="'label.' + property.name | translate"
                [items]="property.directory"
                [attr.data-test]="'folder-edit-modal_' + property.name"
                [formControlName]="property.name.toLowerCase()">
              </sk-select>
            }
          }
        </div>
      }
    </form>
  </ng-container>

  <ng-container id="sk-modal-footer-buttons">
    <sk-button
      [color]="'primary'"
      (click)="onSubmit()"
      data-test="modal-footer-confirm-button"
      [label]="'label.Save' | translate"
      [disabled]="editFolderForm.invalid">
      <ng-template buttonPrefix>
        <i class="fas fa-check"></i>
      </ng-template>
    </sk-button>
  </ng-container>
</sk-modal-content>

<ng-template #nameTemplate let-control let-label="label" let-required="isRequired">
  <sk-text
    [label]="label | translate"
    [formControl]="control"
    [required]="required"
    data-test="folder-edit-modal_name"
  ></sk-text>
</ng-template>
